import React from 'react';
import dayjs from 'dayjs';
import appstore from 'Assets/img/appstore.svg';
import googleplay from 'Assets/img/googleplay.svg';
import logo from 'Assets/img/mono-logo-black.png';
import { useStoreState } from 'easy-peasy';
import { FormattedMessage } from 'react-intl';

// Static FormattedMessage components for translation extraction
const FOOTER_MESSAGES = {
  privacyPolicy: (
    <FormattedMessage
      id="footer-links-privacy-policy"
      description="Label for footer links to privacy policy"
      defaultMessage="Privacy policy"
    />
  ),
  legalTerms: (
    <FormattedMessage
      id="footer-links-legal-terms"
      description="Label for footer links to legal terms"
      defaultMessage="Legal terms"
    />
  ),
  solutionSpecificTerms: solutionName => (
    <FormattedMessage
      id="footer-links-solution-specific-terms"
      description="Label for footer links to solution-specific terms"
      defaultMessage="{solutionName} solution terms"
      values={{ solutionName }}
    />
  ),
  contactUs: (
    <FormattedMessage
      id="footer-links-contact-us"
      description="Label for footer links to contact us"
      defaultMessage="Contact us"
    />
  ),
};

export default () => {
  const solution = useStoreState(state => state.auth.solution);
  const privacy = solution?.policies?.find(p => p.name === 'privacy');
  const nuiTerms = solution?.policies?.find(p => p.name === 'nui-terms');
  const allTerms = solution?.policies?.filter(p => p.name === 'terms') || [];
  const isMarketPlace = !nuiTerms;

  let versionArr = [];
  if (import.meta.env.VITE_APP_TAG) {
    versionArr.push(`Version ${import.meta.env.VITE_APP_TAG}`);
  }
  if (import.meta.env.VITE_APP_COMMIT) {
    versionArr.push(`Version ${import.meta.env.VITE_APP_COMMIT}`);
  }
  if (import.meta.env.VITE_APP_COMMIT_DT) {
    versionArr.push(
      `${dayjs
        .duration(
          dayjs(import.meta.env.VITE_APP_COMMIT_DT * 1000).diff(dayjs())
        )
        .humanize(true)}`
    );
  }
  if (import.meta.env.VITE_APP_DOMAIN_LABEL) {
    versionArr.push(`Endpoint ${import.meta.env.VITE_APP_DOMAIN_LABEL}`);
  }

  return (
    <footer className="footer">
      <div className="row">
        <div className="flex-1">
          <p className="copy">
            <span className="companyname">
              &copy; 2014 - {dayjs().year()} Nui Markets NZ Ltd
            </span>{' '}
            <ul className="footer-links">
              <li>
                <a
                  href={privacy?.url || 'https://www.nuimarkets.com/privacy/'}
                  title="Privacy policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {FOOTER_MESSAGES.privacyPolicy}
                </a>
              </li>
              <li>
                <a
                  href={
                    !isMarketPlace
                      ? nuiTerms?.url
                      : allTerms?.[0]?.url ||
                        'https://www.nuimarkets.com/nui-legal-terms-enterprise/'
                  }
                  title="Legal terms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {FOOTER_MESSAGES.legalTerms}
                </a>
              </li>
              {!isMarketPlace &&
                allTerms
                  .sort((a, b) => (a.solution ? 1 : -1))
                  .map((termPolicy, index) => {
                    const solutionName = termPolicy.solution || solution?.name;
                    return (
                      <li key={index}>
                        <a
                          href={termPolicy.url}
                          title={`${solutionName} solution terms`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {FOOTER_MESSAGES.solutionSpecificTerms(solutionName)}
                        </a>
                      </li>
                    );
                  })}
              <li>
                <a
                  href="https://www.nuimarkets.com/contact/"
                  title="Contact us"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {FOOTER_MESSAGES.contactUs}
                </a>
              </li>
            </ul>
          </p>
        </div>
        <div>
          <p className="applinks">
            <a
              href="https://play.google.com/store/apps/details?id=com.nuimarkets.app"
              className="imglink"
              title="Get it on Google Play"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={googleplay} alt="Get it on Google Play" />
            </a>
            <a
              href="https://apps.apple.com/us/app/nui-markets/id1530875871"
              className="imglink"
              title="Available on the iPhone App Store"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={appstore} alt="Available on the iPhone App Store" />
            </a>
          </p>
        </div>
      </div>

      <hr className="mt-0 mb-0" />

      <div className="logo mt-4">
        <a
          href="https://www.nuimarkets.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={logo} alt="Nui" title={versionArr.join('\n')} />
        </a>
        <p>
          <strong className="m-0">
            <a
              className="powered"
              href="https://www.nuimarkets.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Powered by Nui Markets
            </a>
          </strong>
        </p>
      </div>
    </footer>
  );
};
